/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  ActionLogDTO,
  Address,
  AddressInfoDTO,
  AddressVerifyRequest,
  AddressVerifyResponse,
  AiCargoDTO,
  AiResultResponse,
  AllocateDTO,
  AllocateRequest,
  BatchAllocateRequest,
  BizOperRequest,
  BizOperResponse,
  CancelShipmentRequest,
  CarParamConfigDTO,
  CarrierCountDTO,
  CarrierCountResponse,
  CityDTO,
  CommissionAuditRequest,
  CompanyAddRequest,
  CompanyAuditRequest,
  CompanyDetailResponse,
  CompanyEditRequest,
  CompanyPageResponse,
  CompanyQueryRequest,
  CompanyStatusRequest,
  CreditEditRequest,
  CustomerCreditResponse,
  CustomerQuoteConfigDTO,
  CustomerQuoteInfoDTO,
  CustomerQuoteInfoDetailDTO,
  CustomerResponse,
  ExceptionDealDetailResponse,
  ExceptionDealRequest,
  ExceptionDetailResponse,
  ExceptionPageResponse,
  ExceptionQueryRequest,
  FCashOutApproveRequest,
  FCashOutListResponse,
  FCashOutQueryRequest,
  FCashOutResponse,
  FCustomerWalletRequest,
  FCustomerWalletResponse,
  FHistoryBillRequest,
  FRechargeApproveRequest,
  FRechargeListResponse,
  FRechargeQueryRequest,
  FRechargeResponse,
  FTradeRequest,
  FTransactionResponse,
  FWalletResponse,
  FmcsaCarrier,
  FmcsaCarrierListVO,
  FmcsaQueryRequest,
  FmcsaStatusRequest,
  FreightClassRequest,
  HelperInfoReqeust,
  IPage,
  LocalTime,
  LocalTimeReq,
  LocalTimeRes,
  MailQuoteConfigResponse,
  MainQuoteConfigPageResponse,
  MainQuoteConfigQueryRequest,
  MainQuoteConfigRequest,
  OrderAcceptRequest,
  OrderActionLogResponse,
  OrderAddressDTO,
  OrderAddressDTOReq,
  OrderAddressDTORes,
  OrderAmountRecordDTO,
  OrderAmountRequest,
  OrderAmountResponse,
  OrderBatchIdRequest,
  OrderBidPriceRequest,
  OrderCargoDTO,
  OrderCountDTO,
  OrderCountResponse,
  OrderDetailResponse,
  OrderFileRequest,
  OrderListExtResponse,
  OrderPickDateRequest,
  OrderPriceUpdateRequest,
  OrderQueryRequest,
  OrderQuoteDTO,
  OrderQuoteRequest,
  OrderQuoteResultResponse,
  OrderRefNumberUpdateRequest,
  OrderRequest,
  OrderSimpleCargoDTO,
  OrderSimpleInfoDTO,
  OrderTrackingDTO,
  OssFileResponse,
  OwnerQueryRequest,
  OwnerUserAuditRequest,
  OwnerUserEditRequest,
  OwnerUserPwdRequest,
  OwnerUserRequest,
  OwnerUserResponse,
  PageQuery,
  PlaceDetailResponse,
  PlaceResultDTO,
  PlaceResultResponse,
  PlaceSearchRequest,
  PlatformCommodityDTO,
  PlatformOrderCoreRequest,
  PlatformQuoteConfigUpdateRequest,
  PlatformQuoteRateDTO,
  PlatformRateDetailDTO,
  QueryCityPageDTO,
  QueryQuoteAmountDTO,
  QuoteConfigDTO,
  QuoteInfoDTO,
  QuoteInfoDetailDTO,
  QuoteOrderPriceDTO,
  QuoteResultResponse,
  RouteDetailResponse,
  R,
  SalesAmountReportResponse,
  SalesCustomerRequest,
  SalesCustomerResponse,
  SalesDetailResponse,
  SalesOrderCountRequest,
  SalesOrderRequest,
  SalesOrderResponse,
  SalesQueryRequest,
  SalesSimpleResponse,
  SalesUserRequest,
  SalesUserResponse,
  SalesUserStatusVo,
  ServiceQuoteConfigRequest,
  ServiceQuoteConfigResponse,
  ServiceQuoteConfigUpdateRequest,
  ServiceQuoteDetailDTO,
  ShipmentCountResponse,
  ShipmentDetailExtResponse,
  ShipmentPageExtResponse,
  ShipmentQueryRequest,
  ShipmentTrackResponse,
  SysDepartmentTreeVo,
  SysDepartmentVo,
  SysPermission,
  SysPermissionTreeVo,
  SysPermissionVo,
  SysRoleResultVo,
  SysRoleVo,
  SysUserPasswordVo,
  SysUserQueryVo,
  SysUserStatusVo,
  SysUserVo,
  TimeZoneDTO,
  TrackInfo,
  TrackQueryRequest,
  TransferCenterQueryRequest,
  TransferCenterRequest,
  TransferCenterResponse,
  TranslateRequest,
  TranslateResponse,
  UpdateBatchIdDTO,
  UpdateQuoteConfigDisableDTO,
  UserInfoVo,
  UserLoginVo,
  WaybillBolNoUpdateRequest,
  WaybillCountDTO,
  WaybillCountResponse,
  WaybillDetailResponse,
  WaybillFileResponse,
  WaybillPriceRecordDTO,
  WaybillPriceRequest,
  WaybillPriceResponse,
  WaybillPriceUpdateRequest,
  WaybillQueryRequest,
  WaybillRemarkUpdateRequest,
  WaybillRouteInfoDTO,
  WaybillRouteResponse,
  WaybillTrackLogResponse,
  WaybillTruckUpdateRequest,
  WaybillUpdateDriverRequest,
  WaybillUpdateRequest,
} from './type';
import request from '@/utils/request';

export class OssService {
  // 获取对象信息
  public static getObjectUsingGET(objectName: string): Promise<R<Map<string, object>>> {
    return request('GET', '/oss/object', null, { objectName }, null, null, null);
  }

  // 指定文件名上传oss文件
  public static createObjectUsingPOST(object?: string): Promise<R<string>> {
    return request('POST', '/oss/object', null, null, object, null, null);
  }
}
